import {useQuery} from "@apollo/client";
import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {useParams} from "react-router";

import {Card} from "@/components/card/Card.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {GQL_RUM_TAB_DATA, RUMHeaderInput, RUMTabDataResponse} from "@/lib/queries/rum.ts";
// @ts-expect-error legacy
import {checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
import {RumCheckGraphsEmpty} from "@/pages/rum/v2/details/graphs/RumCheckGraphsEmpty.tsx";
import {RUMGraphs} from "@/pages/rum/v2/details/graphs/RUMPageLoadGraphs.tsx";
import {RUMChartTab, RUMChartTabLabels, RUMChartTabParams} from "@/pages/rum/v2/details/graphs/types.ts";

interface RumCheckGraphsProps {
  className?: string;
  checkName: string;
  headerData: JSON;
  payload: RUMHeaderInput;
  onExtraHeader?: (data: object) => void;
}

export const RumCheckGraphs = ({className, checkName, headerData, onExtraHeader, payload}: RumCheckGraphsProps) => {
  const {id} = useParams();
  const [activeTab, setActiveTab] = useState<RUMChartTab>(RUMChartTab.PAGE_LOAD_TIME);
  const {data, loading, error} = useQuery<RUMTabDataResponse>(GQL_RUM_TAB_DATA, {
    errorPolicy: "all",
    variables: {
      id: parseInt(id!),
      tab: RUMChartTabParams[activeTab],
      payload: payload,
    },
  });

  useEffect(() => {
    const donut = data?.rumTabData?.data.donut;
    if (onExtraHeader && donut) {
      const extra = {};
      // enrich header data with apdex and satisfaction rates
      // header and tab request have to be merged as a single GQL call
      for (const feature of [checkFeatures.apdex, checkFeatures.satisfied]) {
        for (const key of [feature.key, feature.baseline, feature.deltaPct]) {
          // @ts-expect-error legacy
          extra[key] = donut[key];
        }
      }
      onExtraHeader(extra);
    }
  }, [data, onExtraHeader]);

  if (error) {
    console.log(error);
    toast.error("Oops... Something went wrong. Please try again or contact support for assistance.");
  }
  if (loading) {
    return (
      <RumCheckGraphsEmpty className={className} activeTab={activeTab}>
        <LoadingContainer />
      </RumCheckGraphsEmpty>
    );
  }

  return (
    <Card variant="white" className={className}>
      <NavTabs
        className="border-0"
        items={[
          {title: RUMChartTabLabels[RUMChartTab.PAGE_LOAD_TIME], id: RUMChartTab.PAGE_LOAD_TIME},
          {title: RUMChartTabLabels[RUMChartTab.AJAX_LOAD_TIME], id: RUMChartTab.AJAX_LOAD_TIME},
          {title: RUMChartTabLabels[RUMChartTab.ERRORS], id: RUMChartTab.ERRORS},
          {title: RUMChartTabLabels[RUMChartTab.BOUNCE_RATE], id: RUMChartTab.BOUNCE_RATE},
        ]}
        selectedId={activeTab}
        selectTab={(t) => setActiveTab(t as RUMChartTab)}
      />
      {data?.rumTabData?.data && (
        <div className="mt-3 p-2">
          <RUMGraphs
            id={parseInt(id!)}
            checkName={checkName}
            headerData={headerData}
            data={data.rumTabData.data}
            tabName={activeTab}
            payload={payload}
          />
        </div>
      )}
    </Card>
  );
};
